import { Position, Toaster } from '@blueprintjs/core';
// TODO Remove this style after upgrading to blueprint 5
import './toaster.styles.css';

export const AppToaster = Toaster.create({
  position: Position.TOP,
});
